import type { ReactNode } from 'react';
import type { SortHeaderState } from '@/shared/lib';

interface SortHeaderProps<K extends string> extends SortHeaderState<K> {
  className?: string;
  title?: string;
  colSpan?: number;
  children: ReactNode;
}

/**
 * `th[aria-sort] > button.th-sort`: a sortable column header, the markup of the list views.
 * Spread `useTableSort().header(key)` into it, or pass a server-side sort.
 */
export function SortHeader<K extends string>({
  column,
  sort,
  onSort,
  className,
  title,
  colSpan,
  children,
}: SortHeaderProps<K>) {
  const state = sort?.key === column ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none';
  return (
    <th scope="col" className={className} title={title} colSpan={colSpan} aria-sort={state}>
      <button
        type="button"
        className="th-sort"
        onClick={() => {
          onSort(column);
        }}
      >
        {children}
      </button>
    </th>
  );
}
